import { Component, EventEmitter, Input, OnInit, Output, Renderer2, OnDestroy } from '@angular/core';
import { ViewCell } from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';
import { Globals } from '../../../services/globals';

@Component({
  selector: 'app-table-status',
  templateUrl: './table-status.component.html',
  styleUrls: ['./table-status.component.scss']
})
export class TableStatusComponent implements ViewCell, OnInit, OnDestroy {

  renderValue: string;
  showPopup: boolean = true;
  isSoipTable: string = 'email';

  //@Input() value: string | number;
  @Input() value: any = [];
  @Input() rowData: any;
  @Input() newStatus: boolean = false;
  @Input() statusClass: any = '';

  renderColorSpan1: string = '';
  renderColorSpan2: string = '';

  newStatusEnabled = 0;

  @Output() clicked: EventEmitter<any> = new EventEmitter();

  constructor(private renderer: Renderer2, private globals:Globals) {
    this.renderer.addClass(document.body, 'custom-popover');
    this.newStatusEnabled = +sessionStorage.getItem('show_new_status');
  }

  ngOnInit() {
    //console.log( " table status rowData -", this.rowData )
    //console.log( " table status value -", this.value )
    if (this.rowData['is_soip'] == 1) {
      this.isSoipTable = 'rcs';
    }
    if( this.globals.product_type === 'deflector'){
      this.isSoipTable = 'deflector';
    }

    if (typeof this.value === 'object' && this.value !== null) {
      this.renderValue = this.value['statusName'].toString().toLowerCase();
      this.showPopup = this.value['showPopup'];
    }
    else {
      this.renderValue = this.value.toString();
    }

    //console.log(this.renderValue);

    switch (this.renderValue) {

      case 'delivered':
        this.renderColorSpan1 = 'dots-bgcolor-lightgreen';
        this.renderColorSpan2 = 'dots-color-lightgreen';
        break;
      case 'processing':
        this.renderColorSpan1 = 'dots-bgcolor-yellow';
        this.renderColorSpan2 = 'dots-color-yellow';
        break;
      case 'bounced':
        this.renderColorSpan1 = 'dots-bgcolor-darkblue';
        this.renderColorSpan2 = 'dots-color-darkblue';
        break;
      case 'bounce':
        this.renderColorSpan1 = 'dots-bgcolor-darkblue';
        this.renderColorSpan2 = 'dots-color-darkblue';
        break;
      case 'hard bounced':
        this.renderColorSpan1 = 'dots-bgcolor-purple';
        this.renderColorSpan2 = 'dots-color-purple';
        break;
      case 'soft bounced':
        this.renderColorSpan1 = 'dots-bgcolor-lightpurple';
        this.renderColorSpan2 = 'dots-color-lightpurple';
        break;
      case 'invalid':
        this.renderColorSpan1 = 'dots-bgcolor-orange';
        this.renderColorSpan2 = 'dots-color-orange';
        break;
      case 'dropped':
        this.renderColorSpan1 = 'dots-bgcolor-red';
        this.renderColorSpan2 = 'dots-color-red';
        break;
      case 'opened':
        this.renderColorSpan1 = 'dots-bgcolor-lightpurple';
        this.renderColorSpan2 = 'dots-color-lightpurple';
        break;
      case 'clicked':
        this.renderColorSpan1 = 'dots-bgcolor-blue';
        this.renderColorSpan2 = 'dots-color-blue';
        break;
      case 'unsubscribed':
        this.renderColorSpan1 = 'dots-bgcolor-lightOrange';
        this.renderColorSpan2 = 'dots-bgcolor-lightOrange';
        break;
      case 'unsubscribe':
        this.renderColorSpan1 = 'dots-bgcolor-lightblue';
        this.renderColorSpan2 = 'dots-color-lightblue';
        break;
      case 'reported spam':
        this.renderColorSpan1 = 'dots-bgcolor-darkorange';
        this.renderColorSpan2 = 'dots-color-darkorange';
        break;
      case 'spam':
        this.renderColorSpan1 = 'dots-bgcolor-darkorange';
        this.renderColorSpan2 = 'dots-color-darkorange';
        break;
      case 'manual':
        this.renderColorSpan1 = 'dots-bgcolor-lightpurple';
        this.renderColorSpan2 = 'dots-color-lightpurple';
        break;
      case 'cancelled':
        this.renderColorSpan1 = 'dots-bgcolor-pink';
        this.renderColorSpan2 = 'dots-color-pink';
        break;
      case 'scheduled':
        this.renderColorSpan1 = 'dots-bgcolor-yellow';
        this.renderColorSpan2 = 'dots-color-yellow';
        break;
      // SOIP related status 
      case 'sent':
        this.renderColorSpan1 = 'dots-bgcolor-lightpurple';
        this.renderColorSpan2 = 'dots-color-lightpurple';
        break;
      case 'read':
        this.renderColorSpan1 = 'dots-bgcolor-lightblue';
        this.renderColorSpan2 = 'dots-color-lightblue';
        break;
      case 'failed':
        this.renderColorSpan1 = 'dots-bgcolor-red';
        this.renderColorSpan2 = 'dots-color-red';
        break;

      //scheduled pending
      default:
        this.renderColorSpan1 = 'dots-bgcolor-lightblue';
        this.renderColorSpan2 = 'dots-color-lightblue';
        break;
    }
    
  }

  onClick() {
    this.clicked.emit(this.rowData);
    return false;
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'custom-popover');
  }

  getStatusClass(val) {
    switch (val) {
      case 'clicked':
        return 'clicked';
      case 'delivered':
        return 'delivered';
      case 'opened':
        return 'opened';
      case 'unsubscribed':
        return 'unsubscribed';
      case 'reported spam':
        return 'reportedspam';
      case 'cancelled':
        return 'scheduled';
      default:
        return 'delivered'
    }
  }

  getStatus(renderValue){
    switch(renderValue){
      case 'processing':
        return this.newStatusEnabled ? 'Processing' : 'Processing';
      case 'delivered':
        return this.newStatusEnabled ? 'Delivered' : 'Delivered';
      case 'opened':
        return this.newStatusEnabled ? 'Opened' : 'Opened';
      case 'clicked':
        return this.newStatusEnabled ? 'Clicked' : 'Clicked';
      case 'soft bounced':
        return this.newStatusEnabled ? 'Soft bounced' : 'Soft Bounced';
      case 'hard bounced':
        return this.newStatusEnabled ? 'Hard bounced' : 'Hard Bounced';
      case 'reported spam':
        return this.newStatusEnabled ? 'Spam reported' : 'Reported Spam';
      case 'invalid':
        return this.newStatusEnabled ? 'Invalid' : 'Invalid';
      case 'dropped':
        return this.newStatusEnabled ? 'Dropped' : 'Dropped';
      case 'scheduled':
        return this.newStatusEnabled ? 'Scheduled' : 'Scheduled';
      case 'cancelled':
        return this.newStatusEnabled ? 'Cancelled' : 'Cancelled';
      case 'bounced':
        return this.newStatusEnabled ? 'Bounced' : 'Bounced';
      case 'unsubscribed':
        return this.newStatusEnabled ? 'Unsubscribed' : 'Unsubscribed';
      default : return renderValue;
    }
  }
}
